/* ============
 * Address Transformer
 * ============
 *
 * The transformer for the address.
 */

import Transformer from './transformer';

export default class AddressTransformer extends Transformer {
  /**
   * Method used to transform a fetched address
   *
   * @param address The fetched address
   *
   * @returns {Object} The transformed address
   */
  static fetch(address) {
    return {
      careOf: address.care_of,
      streetName: address.street_name,
      secondStreetName: address.second_street_name,
      postalCode: address.postal_code,
      cityName: address.city_name,
      countryId: address.country_id,
    };
  }

  /**
   * Method used to transform a send address
   *
   * @param address The address to be send
   *
   * @returns {Object} The transformed address
   */
  static send(address) {
    return {
      care_of: address.careOf,
      street_name: address.streetName,
      second_street_name: address.secondStreetName,
      postal_code: address.postalCode,
      city_name: address.cityName,
      country_id: address.countryId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/address.js